
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { Connection, PermissionCode, User } from '@/types';
import MiniEditDialog from '@/components/MiniEditDialog.vue';
import PracticeNotesIcon from '@/components/PracticeNotesIcon.vue';

@Component({
  components: {
    MiniEditDialog,
    PracticeNotesIcon,
  },
})
export default class ConnectionPracticeNumber extends Vue {
  @Prop(Object) readonly connection!: Connection | null;

  loading = false

  // Il valore mostrato
  practiceNumber: string | null = null

  created() {
    // console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console

    this.practiceNumber = this.practiceNumberValue;
  }

  get practiceNumberValue() {
    return this.connection?.practiceNumber ?? null;
  }

  @Watch('practiceNumberValue')
  onValue(val: string | null) {
    console.log(`${this.constructor.name}: onValue()`); // eslint-disable-line no-console

    this.practiceNumber = val;
  }

  get user(): User { return this.$store.getters.currentUser; }
  get userPermissions(): PermissionCode[] { return this.$store.getters.currentUserPermissions; }
  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  get isDisabled() {
    return this.loading;
  }

  get isEditable() {
    if (!this.connection) return false;

    return this.connection
      && (this.connection.status === 'open' || this.connection.status === 'new')
      && this.hasPermission('practiceNumber.edit');
  }

  async onSave(newValue: string) {
    console.log(`${this.constructor.name}: onSave()`); // eslint-disable-line no-console

    // Assegna il valore in modo che sia subito mostrato quello aggiornato
    // anche se effettivamente non è ancora stato salvato.
    this.practiceNumber = newValue;

    // Prepara l'aggiornamento
    const update = {
      practiceNumber: this.practiceNumber,
    } as { [key: string]: unknown };

    // Disabilita il campo e richiede l'aggiornamento.
    // Verrà riabilitato ad aggiornamento completato.
    this.loading = true;
    await this.$store.dispatch('updateConnectionFields', {
      id: this.connection?.id,
      fields: update,
      force: true, // Applica immediatamente l'aggiornamento
    });
    this.loading = false;
  }
}
